import React from 'react'
import Button from '../../UiElements/Button'

const PopUp = ({ item, form }) => {
  const Component = item.module
  const View = item.view
  const [visible, setVisible] = React.useState(false)

  return (
    <div>
      <View
        change={form.change}
        data={form.data}
        submit={form.submit}
        validation={form.validation}
        bound={form.bound}
        item={item}
        bind={form.bind}
        popUpVisible={visible}
        show={() => setVisible(true)}
        defaultValues={form.defaultValues}
        valid={form.valid}
      />

      <div
        className={` fixed top-0 left-0 w-[100vw] h-[100vh] z-[100]  py-[100px] overflow-auto bg-gray-600 bg-opacity-50 ${
          item.className || ''
        } ${visible ? '' : 'hidden'}`}
      >
        <style>
          {`
                    ${visible ? 'body {overflow: hidden}' : ''}
                `}
        </style>

        <div
          className={`flex flex-col justify-center items-center min-h-[100vh]  w-[100vw]  PopUpForm PopUpForm_${item?.name}`}
        >
          <div
            className={`bg-white  relative rounded-xl shadow-xl overflow-hidden flex flex-col ${
              item?.innerClassName ? item?.innerClassName : ''
            }`}
          >
            <div className={`PopUpFormContent PopUpFormContent_${item?.name} relative order-2`}>
              {visible && (
                <Component
                  change={form.change}
                  data={form.data}
                  submit={form.submit}
                  validation={form.validation}
                  bound={form.bound}
                  item={item}
                  bind={form.bind}
                  close={() => setVisible(false)}
                  visible={visible}
                  valid={form.valid}
                />
              )}
            </div>
            <div className={'py-md pl-xl pr-md  shadow-xxl flex-row flex items-center relative order-1'}>
              <div className={'flex flex-grow items-center text-title-lg flex-row !h-[100%] justify-start'}>
                {item?.title}
              </div>
              <Button
                className={
                  'font-icon-solid !w-[37px] !h-[37px] overflow-hidden !items-center !justify-center flex text-[18px] !p-0 relative '
                }
                type={'link'}
                onClick={() => setVisible(false)}
              >
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// Return Input in view

export default PopUp
